import { inject } from '@angular/core';
import { type PreferredLanguageEnum, SharedViewerService } from '@reconcept-platform/shared/data-access';
import { LanguageSetter } from '@reconcept-platform/shared/util';
import { catchError, defaultIfEmpty, type Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export const setLanguageWithPreferredLanguageGuard = (
  prefferedLanguage: PreferredLanguageEnum,
): (() => Observable<boolean>) => {
  return () => setLanguage(prefferedLanguage);
};

export const setLanguageGuard = (): Observable<boolean> => setLanguage(undefined);

const setLanguage = (prefferedLanguage?: PreferredLanguageEnum) => {
  const viewerService = inject(SharedViewerService);
  const languageSetter = inject(LanguageSetter);

  return viewerService.getViewer().pipe(
    // a logged-out session check stops in-flight queries, completing this without a value
    defaultIfEmpty(null),
    map((viewer) => {
      languageSetter.setLanguage(viewer?.preferredLanguage ?? prefferedLanguage);
      return true;
    }),
    catchError(() => {
      // also set language if gql fails
      languageSetter.setLanguage(prefferedLanguage);
      return of(true);
    }), // should never block navigation
  );
};
